import { Link, useNavigate, useParams } from "react-router-dom";
import Header from "../../components/Header";
import useFetch from "../features/get";
import { useLocation } from "react-router-dom";
import HotelGallery from "../../components/Hotel/HotelGallery";
import HotelInfo from "../../components/Hotel/HotelInfo";
import RoomList from "../../components/Hotel/RoomList";
import HotelEquipments from "../../components/Hotel/HotelEquipments";

import { useEffect, useState } from "react";
import axios from "axios";
import SectionTabs from "../../components/Hotel/SectionsTabs";
import { BsArrowLeft } from "react-icons/bs";
import BookingCard from "../../components/Hotel/BookingCards";
import LandingHeader from "../../components/LandingHeader";


function Hotel() {
  const [rooms, setRooms] = useState([]);
  const { slug } = useParams();
  const [checkIn, setCheckIn] = useState("");
  const [checkOut, setCheckOut] = useState(""); 
  const [prices, setPrices] = useState([]);
  const [loadingPrices, setLoadingPrices] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();
  const { data, loading } = useFetch(
    `https://api.komorotel.com/api/hotels/slug/${slug}`
  );
  useEffect(() => {
  const params = new URLSearchParams(location.search);

  const checkInParam = params.get("checkIn");
  const checkOutParam = params.get("checkOut");

  if (checkInParam && checkOutParam) {
    setCheckIn(checkInParam);
    setCheckOut(checkOutParam);
  }
}, [location.search]);

useEffect(() => {
  if (!checkIn || !checkOut) return;

  const params = new URLSearchParams(location.search);

  params.set("checkIn", checkIn);
  params.set("checkOut", checkOut);

  navigate(`?${params.toString()}`, { replace: true });

}, [checkIn, checkOut]);

  useEffect(() => {
    if (!data?._id) return;

    const fetchRooms = async () => {
      try {
        const res = await axios.get(
          `https://api.komorotel.com/api/hotels/rooms/${data._id}`
        );
        setRooms(res.data);
      } catch (err) {
        console.log(err);
      }
    };

    fetchRooms();
  }, [data]);
  

useEffect(() => {
  if (!checkIn || !checkOut || !data?._id) return;

  const fetchPrices = async () => {
    try {
      setLoadingPrices(true);

      const res = await axios.get(
        `https://api.komorotel.com/api/tarifs/calculate-hotel-price/${data._id}`,
        {
          params: {
            startDate: checkIn,
            endDate: checkOut,
          },
        }
      );

      setPrices(res.data);

    } catch (err) {
      console.log(err);
    } finally {
      setLoadingPrices(false);
    }
  };

  fetchPrices();
}, [checkIn, checkOut, data]);

  const scrollToSection = (id) => {
    const element = document.getElementById(id);
    if (!element) return;

    const yOffset = -100;
    const y =
      element.getBoundingClientRect().top +
      window.pageYOffset +
      yOffset;

    window.scrollTo({
      top: y,
      behavior: "smooth",
    });
  };

  if (loading) {
    return <div className="pt-28 text-center">Loading...</div>;
  }

  return (
    <div className="bg-white md:bg-gray-50 min-h-screen">

  <div className="hidden md:block">
   <Header />
  </div>

  <div className="w-full md:mt-4">
    <div className="w-full md:max-w-7xl md:mx-auto md:px-6 lg:px-8 px-0">

    <div className="px-0 md:px-6 md:bg-white">

        {/* BACK LINK */}
        <div className="hidden md:block pt-6 mb-3">
          <Link
            to={`/hotels?destination=${encodeURIComponent(data?.island)}&checkIn=&checkOut=`}
            className="inline-flex items-center gap-2 text-sm text-gray-700 bg-white px-4 py-2 rounded-xl border border-gray-200 hover:shadow-sm hover:border-gray-300 transition group"
          >
            <BsArrowLeft className="transition-transform group-hover:-translate-x-1" />
            Revenir aux hôtels de {data?.island}
          </Link>
        </div>

        {/* NAV */}
        <div className="hidden md:block">
          <SectionTabs scrollToSection={scrollToSection} />
        </div>

        {/* FLEX GLOBAL */}
        <div className="flex flex-col lg:flex-row gap-10">

          {/* LEFT */}
          <div className="flex-1">

            {/* GALERIE */}
            <div className="mb-10 -mx-4 sm:-mx-6 lg:mx-0">
              <HotelGallery photos={data.photos} />
            </div>

            {/* INFOS */}
            <div id="presentation" className="mb-10  ">
              <HotelInfo data={data} />
            </div>

            

           <div id="rooms" className="mb-16">

  {/* 🔥 BOOKING MOBILE */}
  <div className="mb-6 lg:hidden px-4 text-center md:text-left">
    <BookingCard
      checkIn={checkIn}
      checkOut={checkOut}
      setCheckIn={setCheckIn}
      setCheckOut={setCheckOut}
    />
  </div>

  <div className="flex flex-col lg:flex-row gap-8">

    {/* LEFT = ROOMS */}
    <div className="flex-1 px-4 md:px-0">
      
        <RoomList
          rooms={rooms}
          checkIn={checkIn}
          checkOut={checkOut}
          prices={prices}
          loadingPrices={loadingPrices}
        />
      
    </div>

    {/* RIGHT = BOOKING (DESKTOP ONLY) */}
    <div className="hidden lg:flex lg:w-[300px] justify-start">
      <div className="w-full max-w-[300px]">
        <BookingCard
          checkIn={checkIn}
          checkOut={checkOut}
          setCheckIn={setCheckIn}
          setCheckOut={setCheckOut}
        />
      </div>
    </div>

  </div>

  {/* SEPARATOR */}
  <div className="mt-12 flex items-center px-4 md:px-0">
    <div className="w-full h-px bg-gradient-to-r from-transparent via-gray-300 to-transparent"></div>
  </div>

</div>

            {/* ÉQUIPEMENTS */}
            <div id="equipements" className="pb-20 ">
              <HotelEquipments equipments={data.equipments} />
            </div>

          </div>

         

        </div>

      </div>

    

    </div>
  </div>

</div>
  );
}

export default Hotel;